import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { withTranslation } from 'react-i18next';

import { forgottenPassword } from '../api/onboarding-api';
import { createAlert } from '../services/alert-service';
import { handleServerError } from 'shared-services/error-service';

import FieldDefault from '../components/field-default';

class ForgottenPassword extends Component {
    static defaultProps = {
        email: ''
    };

    state = {
        email: this.props.email,
        loading: false
    }

    handleEmailChange = (value) => {
        this.setState({
            email: value
        });
    }

    handleSuccessClick = () => {
        this.setState({
            loading: true
        });

        forgottenPassword({
            email: this.state.email
        }).then(response => {
            this.setState({
                loading: false
            });

            createAlert('success', response.message, {
                duration: 7000
            });

            this.props.onSuccess(this.state.email);

        }).catch(error => {
            this.setState({
                loading: false
            });

            handleServerError(error);
        });
    }

    get populated() {
        return this.state.email !== '';
    }

    componentDidUpdate(prevProps) {
        if (prevProps.email !== this.props.email && this.props.email !== this.state.email) {
            this.setState({
                email: this.props.email
            });
        }
    } 

    render() {
        const { t } = this.props;

        return (
            <DocumentTitle title={`${t('password.Forgotten Password')} | Nifty`}>
                <div className="section-forgotten-password">
                    <div className="section-head">
                        <h1>{ t('password.Forgot your password') }</h1>
                    </div>

                    <div className="section-body">
                        <p>{ t('password.forgottenPasswordHelp') }</p>

                        <div className="form">
                            <div className="form-row">
                                <FieldDefault id="login-email" type="email" label={ t('common:Registered work email') } value={this.state.email} onChange={this.handleEmailChange} required={true} placeholder="name@company.com" />
                            </div>
                        </div>
                    </div>

                    <div className="section-foot">
                        <button className="btn btn-secondary" onClick={this.props.onBackClick}>{ t('common:Back') }</button>

                        <button className={'btn btn-success btn-has-loading' + (this.state.loading ? ' loading' : '')} disabled={!this.populated} onClick={this.handleSuccessClick}>{ t('password.Reset Password') }</button>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}

export default withTranslation(['user', 'common'])(ForgottenPassword);
